import { tv } from 'tailwind-variants'

import { caption } from '@ui-kit/core/typography'

export const cardHighlight = tv({
  slots: {
    container: `flex grow flex-col rounded-lg p-3`,
    infoHeader: 'flex flex-row items-baseline pb-1',
    header: 'flex shrink grow flex-row self-start',
    title: caption({ bold: true }),
    titleContainer: 'flex shrink grow flex-row',
    iconContainer: 'pr-2',
    descriptionContainer: 'flex grow flex-col justify-center',
    description: caption(),
  },
  variants: {
    compact: {
      true: {
        container: 'w-[160px]',
      },
    },
  },
  defaultVariants: {
    compact: false,
  },
})
